import { useCallback } from 'react';

import { useMediaQueryContext } from '../context/dynamic/MediaQueryContext';
import { useDataLayerContext } from '../context/static/DataLayerContext';
import { useStaticContext } from '../context/static/StaticContext';
import { useTopLevelNavigationActive } from '~/components/shared/header/topLevelNavigation/hooks/useTopLevelNavigationEnabled';
import type {
  TopLevelNavigationEventType,
  TopLevelNavigationPayloadType,
} from '~/types/topLevelNavigationEvents';

type UseTopNavTrackingReturnType = {
  track: (eventPayload: TopLevelNavigationPayloadType) => void;
};

export const useTopNavTracking = (): UseTopNavTrackingReturnType => {
  const { isDesktop } = useMediaQueryContext();
  const topLevelNavigationActive = useTopLevelNavigationActive();
  const { pushToDataLayer } = useDataLayerContext();
  const {
    configuration: { experienceImpressionEventEnabled },
  } = useStaticContext();

  const track = useCallback(
    (eventPayload: TopLevelNavigationPayloadType) => {
      // Only sites bucketed in the AB test send the event.
      if (!experienceImpressionEventEnabled) {
        return;
      }

      const event: TopLevelNavigationEventType = {
        // Tablet is reported as mobile.
        device_type: isDesktop ? 'desktop' : 'mobile',
        nav_design: topLevelNavigationActive ? 'top_nav_tk69' : 'side_nav',
        ...eventPayload,
      };

      pushToDataLayer(event);
    },
    [experienceImpressionEventEnabled, isDesktop, topLevelNavigationActive, pushToDataLayer]
  );

  return {
    track,
  };
};
